export default {
  '/': () => {
    return import(/* webpackChunkName: "home" */ 'pages/home')
  },
  '/material/home': () => {
    return import(/* webpackChunkName: "material_home" */ 'pages/material/home')
  },
  '/material/faq': () => {
    return import(/* webpackChunkName: "material_faq" */ 'pages/material/faq')
  },
  '/material/faq/add': () => {
    return import(/* webpackChunkName: "material_faq_add" */ 'pages/material/faq_add')
  },
  '/users/admin': () => {
    return import(/* webpackChunkName: "users_admin" */ 'pages/users/admin')
  },
  '/users': () => {
    return import(/* webpackChunkName: "users" */ 'pages/users/index')
  },
  '/material/home/add': () => {
    return import(/* webpackChunkName: "material_home_add" */ 'pages/material/home_add')
  },
  '/tools/card-batch': () => {
    return import(/* webpackChunkName: "tools_card_batch" */ 'pages/tools/card_batch')
  },
  '/tools/card-assets': () => {
    return import(/* webpackChunkName: "tools_card_assets" */ 'pages/tools/card_assets')
  }
}
